export function isSupportImpersonationRouteEnabled(
  value = import.meta.env.VITE_SUPPORT_IMPERSONATION_ENABLED,
) {
  return value !== 'false';
}
